<template lang="pug">
.level.app-levelbar
  .level-left
    .level-item
      h3.subtitle.is-5
        strong {{ name }}
        | (
        transition(name='fade')
          span {{endpoint}}
        | )
  .level-right.is-hidden-mobile
    breadcrumb(:list='list')
</template>

<script>
import Breadcrumb from 'vue-bulma-breadcrumb'
import Tooltip from '../Tooltip'

export default {
  components: {
    Breadcrumb,
    Tooltip
  },

  data () {
    return {
      list: null
    }
  },

  created () {
    this.getList()
  },

  computed: {
    name () {
      return this.$route.name
    },
    endpoint () {
      return this.$store.state.endpoint
    }
  },

  methods: {
    getList () {
      let matched = this.$route.matched.filter(item => item.name)
      let first = matched[0]
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/' }].concat(matched)
      }
      this.list = matched
    }
  },

  watch: {
    $route () {
      this.getList()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Levelbar.vue?c582eb4a